(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cpp-connection-finder-complete"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cpp-complete-finder')) {
  customElements.define('cpp-complete-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (!this.querySelector('[data-sf-config]')) {
        if (!this.startObserver) {
          this.startObserver = new MutationObserver(() => this.connectedCallback());
          this.startObserver.observe(this, {childList:true,subtree:true});
        }
        return;
      }
      this.startObserver?.disconnect();
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-sf-config]').textContent);
      this.family = '';
      this.buttons = [...this.querySelectorAll('[data-sf-family]')];
      this.products = [...this.querySelectorAll('[data-sf-product]')];
      this.target = this.querySelector('select[name="connection_target"]');
      this.optionGroups = this.querySelector('[data-sf-option-groups]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button.dataset.sfFamily)));
      this.querySelector('[data-sf-back]').addEventListener('click', () => this.back());
      this.querySelector('[data-sf-form]').addEventListener('submit', event => {
        event.preventDefault();
        if (this.family && this.target.value && event.currentTarget.reportValidity()) this.showProducts();
      });
      this.target.addEventListener('change', () => {
        this.clearResults();
        this.querySelector('[data-sf-target-note]').textContent = this.target.selectedOptions[0]?.dataset.note || this.config.endNote;
      });
      this.querySelectorAll('[data-sf-check]').forEach(link => link.addEventListener('click', event => {
        const dialog = this.querySelector(`[data-sf-dialog="${link.dataset.sfCheck}"]`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }));
      this.querySelectorAll('[data-sf-dialog]').forEach(dialog => {
        dialog.querySelector('[data-sf-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.querySelector('[data-sf-use]').addEventListener('click', event => {
          const family = event.currentTarget.dataset.sfUse;
          dialog.close();
          requestAnimationFrame(() => this.choose(family));
        });
      });
    }
    clearResults() {
      this.querySelector('[data-sf-results]').hidden = true;
      this.products.forEach(product => {product.hidden = true;});
      this.querySelector('[data-sf-count]').textContent = '';
    }
    populateOptions() {
      const available = new Set(this.products.filter(product => product.dataset.inlet === this.family).map(product => product.dataset.target));
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.config.chooseOption;
      this.target.replaceChildren(placeholder);
      this.optionGroups.content.querySelectorAll('optgroup').forEach(source => {
        const group = source.cloneNode(true);
        group.querySelectorAll('option').forEach(option => {
          if (!available.has(option.value)) option.remove();
        });
        if (group.querySelector('option')) this.target.append(group);
      });
      this.target.value = '';
    }
    choose(family) {
      const button = this.buttons.find(item => item.dataset.sfFamily === family);
      if (!button) return;
      this.family = family;
      this.populateOptions();
      this.clearResults();
      this.querySelector('[data-sf-target-note]').textContent = this.config.endNote;
      this.querySelector('[data-sf-selected-name]').textContent = button.dataset.sfName;
      const image = this.querySelector('[data-sf-selected-image]');
      image.src = button.querySelector('img').src;
      image.hidden = false;
      this.querySelector('[data-sf-step="outlet"]').hidden = true;
      this.querySelector('[data-sf-step="other"]').hidden = false;
      this.querySelector('[data-sf-step="other"] h2').focus({preventScroll:true});
      this.moveToStart();
    }
    back() {
      this.clearResults();
      this.target.value = '';
      this.querySelector('[data-sf-step="other"]').hidden = true;
      this.querySelector('[data-sf-step="outlet"]').hidden = false;
      (this.buttons.find(button => button.dataset.sfFamily === this.family) || this.buttons[0]).focus({preventScroll:true});
      this.family = '';
      this.moveToStart();
    }
    moveToStart() {
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({block:'start',behavior:'instant'});
    }
    showProducts() {
      this.clearResults();
      let count = 0;
      this.products.forEach(product => {
        const match = product.dataset.inlet === this.family && product.dataset.target === this.target.value;
        product.hidden = !match;
        if (match) count++;
      });
      this.querySelector('[data-sf-count]').textContent = `${count} ${count === 1 ? this.config.single : this.config.plural}`;
      this.querySelector('[data-sf-empty]').hidden = count > 0;
      const range = this.querySelector('[data-sf-range]');
      range.hidden = !this.config.ranges[this.family];
      if (this.config.ranges[this.family]) range.href = this.config.ranges[this.family];
      this.querySelector('[data-sf-results]').hidden = false;
      this.querySelector('.sf-result-head h3').focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-connection-finder-simple"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cpp-simple-finder')) {
  customElements.define('cpp-simple-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (!this.querySelector('[data-sf-config]')) {
        if (!this.startObserver) {
          this.startObserver = new MutationObserver(() => this.connectedCallback());
          this.startObserver.observe(this, {childList:true,subtree:true});
        }
        return;
      }
      this.startObserver?.disconnect();
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-sf-config]').textContent);
      this.family = '';
      this.buttons = [...this.querySelectorAll('[data-sf-family]')];
      this.products = [...this.querySelectorAll('[data-sf-product]')];
      this.target = this.querySelector('select[name="connection_target"]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button.dataset.sfFamily)));
      this.querySelector('[data-sf-back]').addEventListener('click', () => this.back());
      this.querySelector('[data-sf-form]').addEventListener('submit', event => {
        event.preventDefault();
        if (this.family && this.target.value && event.currentTarget.reportValidity()) this.showProducts();
      });
      this.target.addEventListener('change', () => {
        this.clearResults();
        this.querySelector('[data-sf-target-note]').textContent = this.config.notes[this.target.value] || '';
      });
      this.querySelectorAll('[data-sf-check]').forEach(link => link.addEventListener('click', event => {
        const dialog = this.querySelector(`[data-sf-dialog="${link.dataset.sfCheck}"]`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }));
      this.querySelectorAll('[data-sf-dialog]').forEach(dialog => {
        dialog.querySelector('[data-sf-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.querySelector('[data-sf-use]').addEventListener('click', event => {
          const family = event.currentTarget.dataset.sfUse;
          dialog.close();
          requestAnimationFrame(() => this.choose(family));
        });
      });
    }
    clearResults() {
      this.querySelector('[data-sf-results]').hidden = true;
      this.products.forEach(product => {product.hidden = true;});
      this.querySelector('[data-sf-count]').textContent = '';
    }
    choose(family) {
      const button = this.buttons.find(item => item.dataset.sfFamily === family);
      if (!button) return;
      this.family = family;
      this.target.value = '';
      this.clearResults();
      this.querySelector('[data-sf-target-note]').textContent = '';
      this.querySelector('[data-sf-selected-name]').textContent = button.dataset.sfName;
      const image = this.querySelector('[data-sf-selected-image]');
      image.src = button.querySelector('img').src;
      image.hidden = false;
      this.querySelector('[data-sf-step="outlet"]').hidden = true;
      this.querySelector('[data-sf-step="other"]').hidden = false;
      this.querySelector('[data-sf-step="other"] h2').focus({preventScroll:true});
      this.moveToStart();
    }
    back() {
      this.clearResults();
      this.target.value = '';
      this.querySelector('[data-sf-step="other"]').hidden = true;
      this.querySelector('[data-sf-step="outlet"]').hidden = false;
      (this.buttons.find(button => button.dataset.sfFamily === this.family) || this.buttons[0]).focus({preventScroll:true});
      this.family = '';
      this.moveToStart();
    }
    moveToStart() {
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({block:'start',behavior:'instant'});
    }
    showProducts() {
      this.clearResults();
      let count = 0;
      this.products.forEach(product => {
        const match = product.dataset.inlet === this.family && product.dataset.target === this.target.value;
        product.hidden = !match;
        if (match) count++;
      });
      this.querySelector('[data-sf-count]').textContent = `${count} ${count === 1 ? this.config.single : this.config.plural}`;
      this.querySelector('[data-sf-empty]').hidden = count > 0;
      const range = this.querySelector('[data-sf-range]');
      range.hidden = !this.config.ranges[this.family];
      if (this.config.ranges[this.family]) range.href = this.config.ranges[this.family];
      this.querySelector('[data-sf-results]').hidden = false;
      this.querySelector('.sf-result-head h3').focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-connection-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cpp-connection-finder')) {
  customElements.define('cpp-connection-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.text = JSON.parse(this.querySelector('[data-cf-text]').textContent);
      this.tabs = [...this.querySelectorAll('[data-mode]')];
      this.measure = this.querySelector('.cf-measure');
      this.finder = this.querySelector('.cf-find');
      this.cards = [...this.querySelectorAll('.cf-product')];
      this.family = '';
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.mode(tab.dataset.mode));
        tab.addEventListener('keydown', event => {
          const keys = {ArrowRight:(index+1)%3, ArrowLeft:(index+2)%3, Home:0, End:2};
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.tabs[keys[event.key]];
          this.mode(next.dataset.mode);
          next.focus();
        });
      });
      this.measure.addEventListener('change', () => {
        this.querySelector('.cf-dimensions').hidden = this.measure.elements.profile.value !== 'coarse';
        this.querySelector('.cf-answer').hidden = true;
      });
      this.measure.addEventListener('input', () => { this.querySelector('.cf-answer').hidden = true; });
      this.measure.elements.units.addEventListener('change', () => {
        this.measure.elements.diameter.value = '';
        this.measure.elements.pitch.value = '';
      });
      this.measure.addEventListener('submit', event => {event.preventDefault(); this.compare();});
      this.querySelectorAll('[data-family]').forEach(button => button.addEventListener('click', () => this.selectFamily(button.dataset.family)));
      this.querySelector('[data-review]').addEventListener('click', () => {this.selectFamily(this.candidate); this.mode('known');});
      this.querySelector('[data-continue]').addEventListener('click', () => this.mode('find'));
      this.finder.addEventListener('change', event => {
        this.clearResults();
        if (event.target.name === 'inlet') {
          this.finder.elements.confirmed.checked = false;
          if (event.target.value) this.selectFamily(event.target.value);
          else {
            this.family = '';
            this.querySelector('.cf-connection').hidden = true;
            this.querySelectorAll('[data-family]').forEach(button => button.setAttribute('aria-pressed','false'));
          }
        }
      });
      this.finder.addEventListener('submit', event => {event.preventDefault(); this.showProducts();});
    }
    mode(mode) {
      this.tabs.forEach(tab => {const active=tab.dataset.mode===mode;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
      this.querySelectorAll('[data-panel]').forEach(panel => {panel.hidden=panel.dataset.panel!==mode;});
    }
    number(value) {
      const text=String(value).trim().replace(',', '.');
      if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)) return NaN;
      return Number(text);
    }
    compare() {
      const form=this.measure.elements, profile=form.profile.value;
      let title=this.text.check_title, copy=this.text.other_answer, measured='';
      this.candidate='';
      if (!profile) copy=this.text.choose_error;
      if (profile==='fine') copy=this.text.fine_answer;
      if (profile==='cam') copy=this.text.cam_answer;
      if (profile==='coarse') {
        const factor=form.units.value==='in'?25.4:1;
        const diameter=this.number(form.diameter.value)*factor, pitch=this.number(form.pitch.value)*factor;
        if (!Number.isFinite(diameter)||!Number.isFinite(pitch)||diameter<=0||pitch<=0||diameter>500||pitch>50) {
          copy=this.text.number_error;
        } else {
          measured=`${this.text.measured} ${diameter.toFixed(2)} mm (${(diameter/25.4).toFixed(3)}″) / ${pitch.toFixed(2)} mm (${(pitch/25.4).toFixed(3)}″)`;
          if (Math.abs(diameter-60)<=3 && Math.abs(pitch-6)<=0.5) this.candidate='s60';
          if (Math.abs(diameter-100)<=3 && Math.abs(pitch-8)<=0.5) this.candidate='s100';
          title=this.candidate?`${this.text.possible} ${this.text[this.candidate]}`:this.text.check_title;
          copy=this.candidate?this.text[`${this.candidate}_detail`]:this.text.no_match;
        }
      }
      const answer=this.querySelector('.cf-answer');
      answer.querySelector('[data-answer-title]').textContent=title;
      answer.querySelector('[data-answer-copy]').textContent=copy;
      answer.querySelector('[data-measured]').textContent=measured;
      answer.querySelector('[data-review]').hidden=!this.candidate;
      answer.hidden=false;
      answer.focus({preventScroll:true});
    }
    selectFamily(family) {
      if (!['s60','nps','cam','s100'].includes(family)) return;
      this.family=family;
      this.finder.elements.inlet.value=family;
      this.finder.elements.confirmed.checked=false;
      this.clearResults();
      this.querySelectorAll('[data-family]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.family===family)));
      this.querySelector('[data-connection-title]').textContent=this.text[family];
      this.querySelector('[data-connection-copy]').textContent=this.text[`${family}_detail`];
      this.querySelector('.cf-connection').hidden=false;
    }
    clearResults() {
      this.querySelector('.cf-results').hidden=true;
      this.querySelector('.cf-error').hidden=true;
      this.cards.forEach(card=>{card.hidden=true;});
    }
    showProducts() {
      const form=this.finder.elements, inlet=form.inlet.value, target=form.target.value;
      this.clearResults();
      const error=this.querySelector('.cf-error');
      if (!inlet||!target||!form.confirmed.checked) {
        error.textContent=!inlet||!target?this.text.choose_error:this.text.confirm_error;
        error.hidden=false;
        if (!inlet) form.inlet.focus(); else if (!target) form.target.focus(); else form.confirmed.focus();
        return;
      }
      let count=0;
      this.cards.forEach(card=>{const match=card.dataset.inlet===inlet&&card.dataset.target===target;card.hidden=!match;if(match)count++;});
      this.querySelector('[data-count]').textContent=`${count} ${this.text.found}`;
      this.querySelector('[data-route]').textContent=`${form.inlet.selectedOptions[0].textContent} → ${form.target.selectedOptions[0].textContent}`;
      this.querySelector('.cf-empty').hidden=count>0;
      const range=this.querySelector('[data-range]');
      range.hidden=!this.text.ranges[inlet];
      if (this.text.ranges[inlet]) range.href=this.text.ranges[inlet];
      this.querySelector('.cf-results').hidden=false;
      this.querySelector('[data-results-title]').focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-fitting-finder-full"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cpp-full-finder')) {
  customElements.define('cpp-full-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('[data-sf-config]');
      if (!configNode) {
        if (!this.startObserver) {
          this.startObserver = new MutationObserver(() => this.connectedCallback());
          this.startObserver.observe(this, {childList:true,subtree:true});
        }
        return;
      }
      let config;
      try { config = JSON.parse(configNode.textContent); } catch (_) {
        if (!this.startObserver) {
          this.startObserver = new MutationObserver(() => this.connectedCallback());
          this.startObserver.observe(this, {childList:true,subtree:true,characterData:true});
        }
        return;
      }
      this.startObserver?.disconnect();
      this.initialized = true;
      this.config = config;
      this.family = '';
      this.buttons = [...this.querySelectorAll('[data-sf-family]')];
      this.products = [...this.querySelectorAll('template[data-sf-product]')];
      this.target = this.querySelector('select[name="connection_target"]');
      this.output = this.querySelector('[data-sf-output]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button.dataset.sfFamily)));
      this.querySelector('[data-sf-back]').addEventListener('click', () => this.back());
      this.querySelector('[data-sf-form]').addEventListener('submit', event => {
        event.preventDefault();
        if (this.family && this.target.value && event.currentTarget.reportValidity()) this.showProducts();
      });
      this.target.addEventListener('change', () => {
        this.clearResults();
        const group = this.target.value.split('_')[0];
        this.querySelector('[data-sf-target-note]').textContent = this.target.value === 'support_checkit' ? this.config.checkit : (this.config.notes[group] || this.config.endNote);
      });
      this.querySelectorAll('[data-sf-check]').forEach(link => link.addEventListener('click', event => {
        const dialog = this.querySelector(`[data-sf-dialog="${link.dataset.sfCheck}"]`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }));
      this.querySelectorAll('[data-sf-dialog]').forEach(dialog => {
        dialog.querySelector('[data-sf-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.querySelector('[data-sf-use]').addEventListener('click', event => {
          const family = event.currentTarget.dataset.sfUse;
          dialog.close();
          requestAnimationFrame(() => this.choose(family));
        });
      });
    }
    clearResults() {
      this.querySelector('[data-sf-results]').hidden = true;
      this.output.replaceChildren();
      this.querySelector('[data-sf-count]').textContent = '';
    }
    buildOptions() {
      this.target.replaceChildren(new Option(this.config.chooseOption, ''), new Option(this.config.all, '*'));
      const available = new Map();
      this.products.filter(product => product.dataset.inlet === this.family).forEach(product => {
        const key = product.dataset.target;
        if (!available.has(key)) available.set(key, {label:product.dataset.label,group:product.dataset.group,count:0});
        available.get(key).count++;
      });
      const orderedKeys = [...available.keys()].sort((a,b) => {
        const ai=this.config.order.indexOf(a), bi=this.config.order.indexOf(b);
        return (ai < 0 ? 9999 : ai) - (bi < 0 ? 9999 : bi) || a.localeCompare(b);
      });
      this.config.groupOrder.forEach(group => {
        const keys = orderedKeys.filter(key => available.get(key).group === group);
        if (!keys.length) return;
        const element = document.createElement('optgroup');
        element.label = this.config.groups[group] || group;
        keys.forEach(key => {element.append(new Option(available.get(key).label, key));});
        this.target.append(element);
      });
      const other = document.createElement('optgroup');
      other.label = this.config.supportGroup;
      if (this.family === 'nps') other.append(new Option(this.config.checkitLabel, 'support_checkit'));
      other.append(new Option(this.config.otherLabel, 'support_other'));
      this.target.append(other);
    }
    choose(family) {
      const button = this.buttons.find(item => item.dataset.sfFamily === family);
      if (!button) return;
      this.family = family;
      this.clearResults();
      this.buildOptions();
      this.target.value = '';
      this.querySelector('[data-sf-target-note]').textContent = this.config.endNote;
      this.querySelector('[data-sf-selected-name]').textContent = button.dataset.sfName;
      const image = this.querySelector('[data-sf-selected-image]');
      image.src = button.querySelector('img').src;
      image.hidden = false;
      this.querySelector('[data-sf-step="outlet"]').hidden = true;
      this.querySelector('[data-sf-step="other"]').hidden = false;
      this.querySelector('[data-sf-step="other"] h2').focus({preventScroll:true});
      this.moveToStart();
    }
    back() {
      this.clearResults();
      this.target.value = '';
      this.querySelector('[data-sf-step="other"]').hidden = true;
      this.querySelector('[data-sf-step="outlet"]').hidden = false;
      (this.buttons.find(button => button.dataset.sfFamily === this.family) || this.buttons[0]).focus({preventScroll:true});
      this.family = '';
      this.moveToStart();
    }
    moveToStart() {
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({block:'start',behavior:'instant'});
    }
    showProducts() {
      this.clearResults();
      const support = this.target.value.startsWith('support_');
      const matches = this.products.filter(product => product.dataset.inlet === this.family && (this.target.value === '*' || product.dataset.target === this.target.value));
      const seen = new Set();
      const fragment = document.createDocumentFragment();
      matches.forEach(product => {
        if (seen.has(product.dataset.sku)) return;
        seen.add(product.dataset.sku);
        fragment.append(product.content.cloneNode(true));
      });
      this.output.append(fragment);
      const count = seen.size;
      this.querySelector('[data-sf-count]').textContent = support ? '' : `${count} ${count === 1 ? this.config.single : this.config.plural}`;
      this.querySelector('[data-sf-empty]').hidden = count > 0;
      this.querySelector('[data-sf-empty-copy]').textContent = this.target.value === 'support_checkit' ? this.config.checkit : (support ? this.config.supportCopy : this.config.empty);
      const range = this.querySelector('[data-sf-range]');
      range.hidden = !this.config.ranges[this.family];
      if (this.config.ranges[this.family]) range.href = this.config.ranges[this.family];
      this.querySelector('[data-sf-results]').hidden = false;
      this.querySelector('.sf-result-head h3').focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-ibc-listing-selector"]) return;
  try {
    
if(!customElements.get('cpp-ibc-listing-selector'))customElements.define('cpp-ibc-listing-selector',class extends HTMLElement{
connectedCallback(){if(this.started)return;document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>this.start(),{once:true}):this.start()}
start(){if(this.started)return;const l=document.querySelector('.cpp-collection'),r=l?.querySelector('.cpp-results'),s=l?.querySelector('.cpp-filters');if(!r||!s)return;this.started=true;this.listing=l;this.results=r;this.config=JSON.parse(this.querySelector('[data-cpl-config]').textContent);this.grid=r.querySelector('.cpp-product-grid');this.counter=r.querySelector('.cpp-results__toolbar > span');this.nativeNav=r.querySelector('.cpp-page-nav');this.sort=r.querySelector('select[name="sort_by"]');this.select=this.querySelector('[data-cpl-select]');this.reset=this.querySelector('[data-cpl-reset]');this.status=this.querySelector('[data-cpl-status]');this.note=this.querySelector('[data-cpl-note]');this.retry=this.querySelector('[data-cpl-retry]');this.nav=document.createElement('nav');this.nav.className='cpp-page-nav cpl-pagination';this.nav.setAttribute('aria-label',this.config.pagination);this.nav.hidden=true;r.append(this.nav);s.prepend(this);this.hidden=false;this.select.addEventListener('change',()=>this.apply(1,'push'));this.reset.addEventListener('click',()=>{this.select.value='';this.apply(1,'push')});this.retry.addEventListener('click',()=>this.load());this.nav.addEventListener('click',e=>{const a=e.target.closest('a[data-cpl-page]');if(!a)return;e.preventDefault();this.apply(Number(a.dataset.cplPage),'push')});this.load()}
sourceUrl(page){const c=new URL(location.href),u=new URL(this.config.collectionUrl,location.origin),sort=c.searchParams.get('sort_by')||this.sort?.value;if(sort)u.searchParams.set('sort_by',sort);if(this.config.previewTheme)u.searchParams.set('preview_theme_id',this.config.previewTheme);u.searchParams.set('section_id','cpp-ibc-connection-source');u.searchParams.set('page',page);return u}
async fetchPage(page){const res=await fetch(this.sourceUrl(page),{credentials:'same-origin'});if(!res.ok)throw Error();const d=new DOMParser().parseFromString(await res.text(),'text/html'),src=d.querySelector('[data-cpp-connection-source]');if(!src||Number(src.dataset.page)!==page)throw Error();return{total:Number(src.dataset.total),pages:Number(src.dataset.pages),items:[...src.querySelectorAll('[data-cpp-connection-item]')]}}
async load(){if(this.loading)return;this.loading=true;this.select.disabled=this.reset.disabled=true;this.status.textContent=this.config.loading;try{const first=await this.fetchPage(1);let items=first.items;for(let p=2;p<=first.pages;p++){const n=await this.fetchPage(p);items=items.concat(n.items)}if(items.length!==first.total)throw Error();this.items=items.map(i=>document.importNode(i,true));this.populate();this.loaded=true;this.listing.classList.add('cpp-collection--ibc-sidebar');if(this.nativeNav)this.nativeNav.hidden=true;if(this.sort){this.sort.removeAttribute('onchange');this.sort.addEventListener('change',()=>{const u=this.stateUrl(1);u.searchParams.set('sort_by',this.sort.value);location.assign(u.href)})}this.select.disabled=this.reset.disabled=false;this.status.textContent='';this.restore('replace')}catch(e){this.status.textContent=this.config.failure;this.retry.hidden=false}finally{this.loading=false}}
populate(){const counts=new Map();this.items.forEach(i=>{if(i.dataset.route)counts.set(i.dataset.route,(counts.get(i.dataset.route)||0)+1)});this.select.replaceChildren(new Option(this.config.all,''));this.querySelector('[data-cpl-groups]').content.querySelectorAll('optgroup').forEach(src=>{const g=src.cloneNode(true);g.querySelectorAll('option').forEach(o=>{const c=counts.get(o.value);if(!c)o.remove();else o.textContent+=` (${c})`});if(g.querySelector('option'))this.select.append(g)})}
restore(mode){const p=new URL(location.href).searchParams,req=p.get('cpp_connection')||'',ok=[...this.select.options].some(o=>o.value===req);this.select.value=ok?req:'';this.status.textContent=ok?'':this.config.invalid;this.apply(Number(p.get('cpp_page')||p.get('page')||1),mode)}
stateUrl(page){const u=new URL(location.href);['page','section_id','sections','cpp_page','cpp_connection'].forEach(k=>u.searchParams.delete(k));[...u.searchParams.keys()].filter(k=>k.startsWith('filter.')).forEach(k=>u.searchParams.delete(k));if(this.select.value)u.searchParams.set('cpp_connection',this.select.value);if(page>1)u.searchParams.set('cpp_page',page);if(this.config.previewTheme)u.searchParams.set('preview_theme_id',this.config.previewTheme);return u}
apply(req,mode){if(!this.loaded)return;const m=this.items.filter(i=>!this.select.value||i.dataset.route===this.select.value),pages=Math.max(1,Math.ceil(m.length/this.config.pageSize)),page=Math.min(pages,Math.max(1,req||1)),v=m.slice((page-1)*this.config.pageSize,page*this.config.pageSize);this.grid.replaceChildren(...v);if(!v.length){const e=document.createElement('p');e.className='cpp-empty';e.textContent=this.config.empty;this.grid.append(e)}const strong=document.createElement('strong');strong.textContent=String(m.length);this.counter.replaceChildren(strong,document.createTextNode(' '+(m.length===1?this.config.single:this.config.plural)));this.note.textContent=this.select.selectedOptions[0]?.dataset.note||this.config.note;this.reset.disabled=!this.select.value&&page===1;this.renderNav(page,pages);if(mode!=='none')history[mode==='push'?'pushState':'replaceState']({},'',this.stateUrl(page))}
renderNav(page,pages){this.nav.replaceChildren();this.nav.hidden=pages<=1;if(pages<=1)return;const mk=(p,t,disabled=false)=>{const a=document.createElement(disabled?'span':'a');a.className='cpp-page-nav__direction';a.textContent=t;if(disabled)a.setAttribute('aria-disabled','true');else{a.href=this.stateUrl(p).href;a.dataset.cplPage=String(p)}return a};this.nav.append(mk(page-1,'← '+this.config.previous,page<=1));const ul=document.createElement('ul');ul.className='cpp-page-nav__pages';for(let p=1;p<=pages;p++){const li=document.createElement('li'),a=document.createElement(p===page?'span':'a');a.className='cpp-page-nav__number';a.textContent=String(p);if(p===page){a.classList.add('cpp-page-nav__current');a.setAttribute('aria-current','page')}else{a.href=this.stateUrl(p).href;a.dataset.cplPage=String(p)}li.append(a);ul.append(li)}this.nav.append(ul,mk(page+1,this.config.next+' →',page>=pages))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-range-listing-selector"]) return;
  try {
    
if (!customElements.get('cpp-range-listing-selector')) {
  customElements.define('cpp-range-listing-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (document.readyState === 'loading') {
        if (!this.onReady) {
          this.onReady = () => this.start();
          document.addEventListener('DOMContentLoaded', this.onReady, {once:true});
        }
      } else this.start();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          window.removeEventListener('popstate', this.onPop);
          document.removeEventListener('DOMContentLoaded', this.onReady);
        }
      });
    }
    start() {
      if (this.started || !this.isConnected) return;
      const listing = document.querySelector('.cpp-collection');
      const results = listing?.querySelector('.cpp-results');
      const sidebar = listing?.querySelector('.cpp-filters');
      if (!results || !sidebar || !this.querySelector('[data-cpl-config]')) return;
      this.started = true;
      this.listing = listing;
      this.results = results;
      this.config = JSON.parse(this.querySelector('[data-cpl-config]').textContent);
      this.grid = results.querySelector('.cpp-product-grid');
      this.counter = results.querySelector('.cpp-results__toolbar > span');
      this.nativeNav = results.querySelector('.cpp-page-nav');
      this.sort = results.querySelector('select[name="sort_by"]');
      this.select = this.querySelector('[data-cpl-select]');
      this.firstSelect = this.querySelector('[data-cpr-first-select]');
      this.reset = this.querySelector('[data-cpl-reset]');
      this.status = this.querySelector('[data-cpl-status]');
      this.note = this.querySelector('[data-cpl-note]');
      this.retry = this.querySelector('[data-cpl-retry]');
      this.nav = document.createElement('nav');
      this.nav.className = 'cpp-page-nav cpl-pagination';
      this.nav.setAttribute('aria-label', this.config.pagination);
      this.nav.hidden = true;
      results.append(this.nav);
      sidebar.prepend(this);
      this.dataset.cplMounted = 'left';
      this.hidden = false;
      this.select.addEventListener('change', () => this.apply(1, 'push'));
      this.firstSelect.addEventListener('change', () => { this.select.value = ''; this.populateConnections(); this.apply(1, 'push'); });
      this.reset.addEventListener('click', () => {this.firstSelect.value = ''; this.select.value = ''; this.populateConnections(); this.apply(1, 'push');});
      this.retry.addEventListener('click', () => this.load());
      this.nav.addEventListener('click', event => {
        const link = event.target.closest('a[data-cpl-page]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.apply(Number(link.dataset.cplPage), 'push');
        this.counter.tabIndex = -1;
        this.counter.focus({preventScroll:true});
        this.counter.scrollIntoView({block:'nearest', behavior:'instant'});
      });
      this.onPop = () => {if (this.loaded) this.restore('none');};
      window.addEventListener('popstate', this.onPop);
      this.load();
    }
    sourceUrl(page) {
      const current = new URL(location.href);
      const url = new URL(this.config.collectionUrl, location.origin);
      const sort = current.searchParams.get('sort_by') || this.sort?.value;
      if (sort) url.searchParams.set('sort_by', sort);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      url.searchParams.set('section_id', 'cpp-range-connection-source');
      url.searchParams.set('page', page);
      return url;
    }
    async fetchPage(page) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.sourceUrl(page), {credentials:'same-origin', signal:controller.signal});
        if (!response.ok || new URL(response.url || this.sourceUrl(page)).origin !== location.origin) throw new Error('Source unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-cpp-connection-source]');
        if (!source || Number(source.dataset.page) !== page) throw new Error('Invalid source');
        const total = Number(source.dataset.total), pages = Number(source.dataset.pages);
        if (!Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages < 0 || pages > 20) throw new Error('Invalid pagination');
        return {total, pages, items:[...source.querySelectorAll('[data-cpp-connection-item]')]};
      } finally {clearTimeout(timer);}
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.firstSelect.disabled = this.select.disabled = this.reset.disabled = true;
      this.retry.hidden = true;
      this.status.textContent = this.config.loading;
      try {
        const first = await this.fetchPage(1);
        let items = first.items;
        for (let page = 2; page <= first.pages; page++) {
          const next = await this.fetchPage(page);
          if (next.total !== first.total || next.pages !== first.pages) throw new Error('Catalogue changed');
          items = items.concat(next.items);
        }
        if (items.length !== first.total || new Set(items.map(item => item.dataset.productId)).size !== items.length) throw new Error('Incomplete collection');
        if (!this.isConnected) return;
        this.items = items.map(item => document.importNode(item, true));
        this.items.forEach(item => {
          const labels = item.querySelector('[data-cpr-labels]')?.content.querySelector('[data-cpr-first]');
          if (!labels) throw new Error('Missing connection labels');
          item.dataset.first = labels.dataset.cprFirst;
          item.dataset.route = labels.dataset.cprSecond;
          item.dataset.group = labels.dataset.cprGroup;
        });
        this.populate();
        this.loaded = true;
        this.listing.classList.add('cpp-collection--range-sidebar');
        if (this.nativeNav) this.nativeNav.hidden = true;
        if (this.sort) {
          this.sort.removeAttribute('onchange');
          this.sort.addEventListener('change', () => {
            const url = this.stateUrl(1);
            url.searchParams.set('sort_by', this.sort.value);
            location.assign(url.href);
          });
        }
        this.firstSelect.disabled = this.select.disabled = this.reset.disabled = false;
        this.status.textContent = '';
        this.restore('replace');
        this.dataset.cplLoaded = 'true';
      } catch (error) {
        this.status.textContent = this.config.failure;
        this.retry.hidden = false;
      } finally {this.loading = false;}
    }
    populate() {
      const counts = new Map();
      this.items.forEach(item => counts.set(item.dataset.first, (counts.get(item.dataset.first) || 0) + 1));
      this.firstSelect.replaceChildren(new Option(this.config.all_first, ''));
      [...counts].sort(([a],[b]) => a.localeCompare(b, undefined, {numeric:true})).forEach(([label,count]) => {
        this.firstSelect.append(new Option(`${label} (${count})`, label));
      });
      this.populateConnections();
    }
    populateConnections() {
      const counts = new Map();
      this.items.filter(item => !this.firstSelect.value || item.dataset.first === this.firstSelect.value).forEach(item => {
        const route = item.dataset.route;
        const entry = counts.get(route) || {count:0, group:item.dataset.group};
        entry.count++;
        counts.set(route, entry);
      });
      this.select.replaceChildren(new Option(this.config.all, ''));
      Object.entries(this.config.groups).forEach(([key,label]) => {
        const group = document.createElement('optgroup');
        group.label = label;
        [...counts].filter(([,entry]) => entry.group === key).sort(([a],[b]) => a.localeCompare(b, undefined, {numeric:true})).forEach(([route,entry]) => {
          group.append(new Option(`${route} (${entry.count})`, route));
        });
        if (group.children.length) this.select.append(group);
      });
    }
    restore(historyMode) {
      const params = new URL(location.href).searchParams;
      const first = params.get('cpp_first') || '';
      const firstExists = [...this.firstSelect.options].some(option => option.value === first);
      this.firstSelect.value = firstExists ? first : '';
      this.populateConnections();
      const requested = params.get('cpp_connection') || '';
      const exists = [...this.select.options].some(option => option.value === requested);
      this.select.value = exists ? requested : '';
      this.status.textContent = firstExists && exists ? '' : this.config.invalid;
      this.apply(Number(params.get('cpp_page') || params.get('page') || 1), historyMode);
    }
    stateUrl(page) {
      const url = new URL(location.href);
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.') || ['page','section_id','sections','cpp_page','cpp_connection','cpp_first'].includes(key)) url.searchParams.delete(key);
      });
      if (this.firstSelect.value) url.searchParams.set('cpp_first', this.firstSelect.value);
      if (this.select.value) url.searchParams.set('cpp_connection', this.select.value);
      if (page > 1) url.searchParams.set('cpp_page', page);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      return url;
    }
    apply(requestedPage, historyMode) {
      if (!this.loaded) return;
      const matches = this.items.filter(item => (!this.firstSelect.value || item.dataset.first === this.firstSelect.value) && (!this.select.value || item.dataset.route === this.select.value));
      const pageCount = Math.max(1, Math.ceil(matches.length / this.config.pageSize));
      const page = Math.min(pageCount, Math.max(1, Number.isInteger(requestedPage) ? requestedPage : 1));
      const visible = matches.slice((page - 1) * this.config.pageSize, page * this.config.pageSize);
      this.grid.replaceChildren(...visible);
      if (!visible.length) {
        const empty = document.createElement('p');
        empty.className = 'cpp-empty';
        empty.textContent = this.config.empty;
        this.grid.append(empty);
      }
      const count = document.createElement('strong');
      count.textContent = String(matches.length);
      this.counter.replaceChildren(count, document.createTextNode(` ${matches.length === 1 ? this.config.single : this.config.plural}`));
      this.counter.setAttribute('role','status');
      this.counter.setAttribute('aria-live','polite');
      const selected = matches[0];
      this.note.textContent = this.select.value && selected ? this.config.notes[selected.dataset.group] || this.config.note : this.config.note;
      this.reset.disabled = !this.firstSelect.value && !this.select.value && page === 1;
      this.renderPagination(page, pageCount);
      if (historyMode !== 'none') history[historyMode === 'push' ? 'pushState' : 'replaceState']({}, '', this.stateUrl(page));
    }
    pageControl(page, label, className, enabled, current = false) {
      const element = document.createElement(enabled && !current ? 'a' : 'span');
      element.className = className;
      element.textContent = label;
      if (current) {
        element.classList.add('cpp-page-nav__current');
        element.setAttribute('aria-current','page');
      } else if (enabled) {
        element.href = this.stateUrl(page).href;
        element.dataset.cplPage = String(page);
      } else {
        element.classList.add('cpp-page-nav__disabled');
        element.setAttribute('aria-disabled','true');
      }
      return element;
    }
    renderPagination(page, pages) {
      this.nav.replaceChildren();
      this.nav.hidden = pages <= 1;
      if (pages <= 1) return;
      this.nav.append(this.pageControl(page - 1, `← ${this.config.previous}`, 'cpp-page-nav__direction', page > 1));
      const list = document.createElement('ul');
      list.className = 'cpp-page-nav__pages';
      let previousNumber = 0;
      const numbers = [...new Set([1, page-1, page, page+1, pages].filter(number => number >= 1 && number <= pages))].sort((a,b) => a-b);
      numbers.forEach(number => {
        if (number > previousNumber + 1) {
          const gap = document.createElement('li');
          gap.textContent = '…';
          gap.className = 'cpp-page-nav__ellipsis';
          list.append(gap);
        }
        const li = document.createElement('li');
        const control = this.pageControl(number, String(number), 'cpp-page-nav__number', true, number === page);
        control.setAttribute('aria-label', `${this.config.page} ${number}`);
        li.append(control);
        list.append(li);
        previousNumber = number;
      });
      this.nav.append(list, this.pageControl(page + 1, `${this.config.next} →`, 'cpp-page-nav__direction', page < pages));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-s60-listing-selector-top-backup"]) return;
  try {
    
if (!customElements.get('cpp-listing-selector')) {
  customElements.define('cpp-listing-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (document.readyState === 'loading') {
        if (!this.onReady) {
          this.onReady = () => this.start();
          document.addEventListener('DOMContentLoaded', this.onReady, {once:true});
        }
      } else this.start();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          window.removeEventListener('popstate', this.onPop);
          document.removeEventListener('DOMContentLoaded', this.onReady);
        }
      });
    }
    start() {
      if (this.started || !this.isConnected) return;
      const listing = document.querySelector('.cpp-collection');
      const results = listing?.querySelector('.cpp-results');
      if (!results || !this.querySelector('[data-cpl-config]')) return;
      this.started = true;
      this.listing = listing;
      this.results = results;
      this.config = JSON.parse(this.querySelector('[data-cpl-config]').textContent);
      this.grid = results.querySelector('.cpp-product-grid');
      this.counter = results.querySelector('.cpp-results__toolbar > span');
      this.nativeNav = results.querySelector('.cpp-page-nav');
      this.sort = results.querySelector('select[name="sort_by"]');
      this.select = this.querySelector('[data-cpl-select]');
      this.reset = this.querySelector('[data-cpl-reset]');
      this.status = this.querySelector('[data-cpl-status]');
      this.note = this.querySelector('[data-cpl-note]');
      this.retry = this.querySelector('[data-cpl-retry]');
      this.nav = document.createElement('nav');
      this.nav.className = 'cpp-page-nav cpl-pagination';
      this.nav.setAttribute('aria-label', this.config.pagination);
      this.nav.hidden = true;
      results.append(this.nav);
      results.prepend(this);
      this.hidden = false;
      this.select.addEventListener('change', () => this.apply(1, 'push'));
      this.reset.addEventListener('click', () => {this.select.value = ''; this.apply(1, 'push');});
      this.retry.addEventListener('click', () => this.load());
      this.nav.addEventListener('click', event => {
        const link = event.target.closest('a[data-cpl-page]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.apply(Number(link.dataset.cplPage), 'push');
        this.counter.tabIndex = -1;
        this.counter.focus({preventScroll:true});
        this.counter.scrollIntoView({block:'nearest', behavior:'instant'});
      });
      this.onPop = () => {if (this.loaded) this.restore('none');};
      window.addEventListener('popstate', this.onPop);
      this.load();
    }
    sourceUrl(page) {
      const current = new URL(location.href);
      const url = new URL(this.config.collectionUrl, location.origin);
      const sort = current.searchParams.get('sort_by') || this.sort?.value;
      if (sort) url.searchParams.set('sort_by', sort);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      url.searchParams.set('section_id', 'cpp-s60-connection-source');
      url.searchParams.set('page', page);
      return url;
    }
    async fetchPage(page) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.sourceUrl(page), {credentials:'same-origin', signal:controller.signal});
        if (!response.ok || new URL(response.url || this.sourceUrl(page)).origin !== location.origin) throw new Error('Source unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-cpp-connection-source]');
        if (!source || Number(source.dataset.page) !== page) throw new Error('Invalid source');
        const total = Number(source.dataset.total), pages = Number(source.dataset.pages);
        if (!Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages < 0 || pages > 20) throw new Error('Invalid pagination');
        return {total, pages, items:[...source.querySelectorAll('[data-cpp-connection-item]')]};
      } finally {clearTimeout(timer);}
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.select.disabled = this.reset.disabled = true;
      this.retry.hidden = true;
      this.status.textContent = this.config.loading;
      try {
        const first = await this.fetchPage(1);
        let items = first.items;
        for (let page = 2; page <= first.pages; page++) {
          const next = await this.fetchPage(page);
          if (next.total !== first.total || next.pages !== first.pages) throw new Error('Catalogue changed');
          items = items.concat(next.items);
        }
        if (items.length !== first.total || new Set(items.map(item => item.dataset.productId)).size !== items.length) throw new Error('Incomplete collection');
        if (!this.isConnected) return;
        this.items = items.map(item => document.importNode(item, true));
        this.populate();
        this.loaded = true;
        this.listing.classList.add('cpp-collection--connection-test');
        if (this.nativeNav) this.nativeNav.hidden = true;
        if (this.sort) {
          this.sort.removeAttribute('onchange');
          this.sort.addEventListener('change', () => {
            const url = this.stateUrl(1);
            url.searchParams.set('sort_by', this.sort.value);
            location.assign(url.href);
          });
        }
        this.select.disabled = this.reset.disabled = false;
        this.status.textContent = '';
        this.restore('replace');
      } catch (error) {
        this.status.textContent = this.config.failure;
        this.retry.hidden = false;
      } finally {this.loading = false;}
    }
    populate() {
      const counts = new Map();
      this.items.forEach(item => {if (item.dataset.route) counts.set(item.dataset.route, (counts.get(item.dataset.route) || 0) + 1);});
      this.select.replaceChildren(new Option(this.config.all, ''));
      this.querySelector('[data-cpl-groups]').content.querySelectorAll('optgroup').forEach(source => {
        const group = source.cloneNode(true);
        group.querySelectorAll('option').forEach(option => {
          const count = counts.get(option.value);
          if (!count) option.remove();
          else option.textContent += ` (${count})`;
        });
        if (group.querySelector('option')) this.select.append(group);
      });
    }
    restore(historyMode) {
      const params = new URL(location.href).searchParams;
      const requested = params.get('cpp_connection') || '';
      const exists = [...this.select.options].some(option => option.value === requested);
      this.select.value = exists ? requested : '';
      this.status.textContent = exists ? '' : this.config.invalid;
      this.apply(Number(params.get('cpp_page') || params.get('page') || 1), historyMode);
    }
    stateUrl(page) {
      const url = new URL(location.href);
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.') || ['page','section_id','sections','cpp_page','cpp_connection'].includes(key)) url.searchParams.delete(key);
      });
      if (this.select.value) url.searchParams.set('cpp_connection', this.select.value);
      if (page > 1) url.searchParams.set('cpp_page', page);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      return url;
    }
    apply(requestedPage, historyMode) {
      if (!this.loaded) return;
      const matches = this.items.filter(item => !this.select.value || item.dataset.route === this.select.value);
      const pageCount = Math.max(1, Math.ceil(matches.length / this.config.pageSize));
      const page = Math.min(pageCount, Math.max(1, Number.isInteger(requestedPage) ? requestedPage : 1));
      const visible = matches.slice((page - 1) * this.config.pageSize, page * this.config.pageSize);
      this.grid.replaceChildren(...visible);
      if (!visible.length) {
        const empty = document.createElement('p');
        empty.className = 'cpp-empty';
        empty.textContent = this.config.empty;
        this.grid.append(empty);
      }
      const count = document.createElement('strong');
      count.textContent = String(matches.length);
      this.counter.replaceChildren(count, document.createTextNode(` ${matches.length === 1 ? this.config.single : this.config.plural}`));
      this.counter.setAttribute('role','status');
      this.counter.setAttribute('aria-live','polite');
      this.note.textContent = this.select.selectedOptions[0]?.dataset.note || this.config.note;
      this.reset.disabled = !this.select.value && page === 1;
      this.renderPagination(page, pageCount);
      if (historyMode !== 'none') history[historyMode === 'push' ? 'pushState' : 'replaceState']({}, '', this.stateUrl(page));
    }
    pageControl(page, label, className, enabled, current = false) {
      const element = document.createElement(enabled && !current ? 'a' : 'span');
      element.className = className;
      element.textContent = label;
      if (current) {
        element.classList.add('cpp-page-nav__current');
        element.setAttribute('aria-current','page');
      } else if (enabled) {
        element.href = this.stateUrl(page).href;
        element.dataset.cplPage = String(page);
      } else {
        element.classList.add('cpp-page-nav__disabled');
        element.setAttribute('aria-disabled','true');
      }
      return element;
    }
    renderPagination(page, pages) {
      this.nav.replaceChildren();
      this.nav.hidden = pages <= 1;
      if (pages <= 1) return;
      this.nav.append(this.pageControl(page - 1, `← ${this.config.previous}`, 'cpp-page-nav__direction', page > 1));
      const list = document.createElement('ul');
      list.className = 'cpp-page-nav__pages';
      let previousNumber = 0;
      const numbers = [...new Set([1, page-1, page, page+1, pages].filter(number => number >= 1 && number <= pages))].sort((a,b) => a-b);
      numbers.forEach(number => {
        if (number > previousNumber + 1) {
          const gap = document.createElement('li');
          gap.textContent = '…';
          gap.className = 'cpp-page-nav__ellipsis';
          list.append(gap);
        }
        const li = document.createElement('li');
        const control = this.pageControl(number, String(number), 'cpp-page-nav__number', true, number === page);
        control.setAttribute('aria-label', `${this.config.page} ${number}`);
        li.append(control);
        list.append(li);
        previousNumber = number;
      });
      this.nav.append(list, this.pageControl(page + 1, `${this.config.next} →`, 'cpp-page-nav__direction', page < pages));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-s60-listing-selector"]) return;
  try {
    
if (!customElements.get('cpp-listing-sidebar-selector')) {
  customElements.define('cpp-listing-sidebar-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (document.readyState === 'loading') {
        if (!this.onReady) {
          this.onReady = () => this.start();
          document.addEventListener('DOMContentLoaded', this.onReady, {once:true});
        }
      } else this.start();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          window.removeEventListener('popstate', this.onPop);
          document.removeEventListener('DOMContentLoaded', this.onReady);
        }
      });
    }
    start() {
      if (this.started || !this.isConnected) return;
      const listing = document.querySelector('.cpp-collection');
      const results = listing?.querySelector('.cpp-results');
      const sidebar = listing?.querySelector('.cpp-filters');
      if (!results || !sidebar || !this.querySelector('[data-cpl-config]')) return;
      this.started = true;
      this.listing = listing;
      this.results = results;
      this.config = JSON.parse(this.querySelector('[data-cpl-config]').textContent);
      this.grid = results.querySelector('.cpp-product-grid');
      this.counter = results.querySelector('.cpp-results__toolbar > span');
      this.nativeNav = results.querySelector('.cpp-page-nav');
      this.sort = results.querySelector('select[name="sort_by"]');
      this.select = this.querySelector('[data-cpl-select]');
      this.reset = this.querySelector('[data-cpl-reset]');
      this.status = this.querySelector('[data-cpl-status]');
      this.note = this.querySelector('[data-cpl-note]');
      this.retry = this.querySelector('[data-cpl-retry]');
      this.nav = document.createElement('nav');
      this.nav.className = 'cpp-page-nav cpl-pagination';
      this.nav.setAttribute('aria-label', this.config.pagination);
      this.nav.hidden = true;
      results.append(this.nav);
      sidebar.prepend(this);
      this.dataset.cplMounted = 'left';
      this.hidden = false;
      this.select.addEventListener('change', () => this.apply(1, 'push'));
      this.reset.addEventListener('click', () => {this.select.value = ''; this.apply(1, 'push');});
      this.retry.addEventListener('click', () => this.load());
      this.nav.addEventListener('click', event => {
        const link = event.target.closest('a[data-cpl-page]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.apply(Number(link.dataset.cplPage), 'push');
        this.counter.tabIndex = -1;
        this.counter.focus({preventScroll:true});
        this.counter.scrollIntoView({block:'nearest', behavior:'instant'});
      });
      this.onPop = () => {if (this.loaded) this.restore('none');};
      window.addEventListener('popstate', this.onPop);
      this.load();
    }
    sourceUrl(page) {
      const current = new URL(location.href);
      const url = new URL(this.config.collectionUrl, location.origin);
      const sort = current.searchParams.get('sort_by') || this.sort?.value;
      if (sort) url.searchParams.set('sort_by', sort);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      url.searchParams.set('section_id', 'cpp-s60-connection-source');
      url.searchParams.set('page', page);
      return url;
    }
    async fetchPage(page) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.sourceUrl(page), {credentials:'same-origin', signal:controller.signal});
        if (!response.ok || new URL(response.url || this.sourceUrl(page)).origin !== location.origin) throw new Error('Source unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-cpp-connection-source]');
        if (!source || Number(source.dataset.page) !== page) throw new Error('Invalid source');
        const total = Number(source.dataset.total), pages = Number(source.dataset.pages);
        if (!Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages < 0 || pages > 20) throw new Error('Invalid pagination');
        return {total, pages, items:[...source.querySelectorAll('[data-cpp-connection-item]')]};
      } finally {clearTimeout(timer);}
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.select.disabled = this.reset.disabled = true;
      this.retry.hidden = true;
      this.status.textContent = this.config.loading;
      try {
        const first = await this.fetchPage(1);
        let items = first.items;
        for (let page = 2; page <= first.pages; page++) {
          const next = await this.fetchPage(page);
          if (next.total !== first.total || next.pages !== first.pages) throw new Error('Catalogue changed');
          items = items.concat(next.items);
        }
        if (items.length !== first.total || new Set(items.map(item => item.dataset.productId)).size !== items.length) throw new Error('Incomplete collection');
        if (!this.isConnected) return;
        this.items = items.map(item => document.importNode(item, true));
        this.populate();
        this.loaded = true;
        this.listing.classList.add('cpp-collection--sidebar-test');
        if (this.nativeNav) this.nativeNav.hidden = true;
        if (this.sort) {
          this.sort.removeAttribute('onchange');
          this.sort.addEventListener('change', () => {
            const url = this.stateUrl(1);
            url.searchParams.set('sort_by', this.sort.value);
            location.assign(url.href);
          });
        }
        this.select.disabled = this.reset.disabled = false;
        this.status.textContent = '';
        this.restore('replace');
        this.dataset.cplLoaded = 'true';
      } catch (error) {
        this.status.textContent = this.config.failure;
        this.retry.hidden = false;
      } finally {this.loading = false;}
    }
    populate() {
      const counts = new Map();
      this.items.forEach(item => {if (item.dataset.route) counts.set(item.dataset.route, (counts.get(item.dataset.route) || 0) + 1);});
      this.select.replaceChildren(new Option(this.config.all, ''));
      this.querySelector('[data-cpl-groups]').content.querySelectorAll('optgroup').forEach(source => {
        const group = source.cloneNode(true);
        group.querySelectorAll('option').forEach(option => {
          const count = counts.get(option.value);
          if (!count) option.remove();
          else option.textContent += ` (${count})`;
        });
        if (group.querySelector('option')) this.select.append(group);
      });
    }
    restore(historyMode) {
      const params = new URL(location.href).searchParams;
      const requested = params.get('cpp_connection') || '';
      const exists = [...this.select.options].some(option => option.value === requested);
      this.select.value = exists ? requested : '';
      this.status.textContent = exists ? '' : this.config.invalid;
      this.apply(Number(params.get('cpp_page') || params.get('page') || 1), historyMode);
    }
    stateUrl(page) {
      const url = new URL(location.href);
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.') || ['page','section_id','sections','cpp_page','cpp_connection'].includes(key)) url.searchParams.delete(key);
      });
      if (this.select.value) url.searchParams.set('cpp_connection', this.select.value);
      if (page > 1) url.searchParams.set('cpp_page', page);
      if (this.config.previewTheme) url.searchParams.set('preview_theme_id', this.config.previewTheme);
      return url;
    }
    apply(requestedPage, historyMode) {
      if (!this.loaded) return;
      const matches = this.items.filter(item => !this.select.value || item.dataset.route === this.select.value);
      const pageCount = Math.max(1, Math.ceil(matches.length / this.config.pageSize));
      const page = Math.min(pageCount, Math.max(1, Number.isInteger(requestedPage) ? requestedPage : 1));
      const visible = matches.slice((page - 1) * this.config.pageSize, page * this.config.pageSize);
      this.grid.replaceChildren(...visible);
      if (!visible.length) {
        const empty = document.createElement('p');
        empty.className = 'cpp-empty';
        empty.textContent = this.config.empty;
        this.grid.append(empty);
      }
      const count = document.createElement('strong');
      count.textContent = String(matches.length);
      this.counter.replaceChildren(count, document.createTextNode(` ${matches.length === 1 ? this.config.single : this.config.plural}`));
      this.counter.setAttribute('role','status');
      this.counter.setAttribute('aria-live','polite');
      this.note.textContent = this.select.selectedOptions[0]?.dataset.note || this.config.note;
      this.reset.disabled = !this.select.value && page === 1;
      this.renderPagination(page, pageCount);
      if (historyMode !== 'none') history[historyMode === 'push' ? 'pushState' : 'replaceState']({}, '', this.stateUrl(page));
    }
    pageControl(page, label, className, enabled, current = false) {
      const element = document.createElement(enabled && !current ? 'a' : 'span');
      element.className = className;
      element.textContent = label;
      if (current) {
        element.classList.add('cpp-page-nav__current');
        element.setAttribute('aria-current','page');
      } else if (enabled) {
        element.href = this.stateUrl(page).href;
        element.dataset.cplPage = String(page);
      } else {
        element.classList.add('cpp-page-nav__disabled');
        element.setAttribute('aria-disabled','true');
      }
      return element;
    }
    renderPagination(page, pages) {
      this.nav.replaceChildren();
      this.nav.hidden = pages <= 1;
      if (pages <= 1) return;
      this.nav.append(this.pageControl(page - 1, `← ${this.config.previous}`, 'cpp-page-nav__direction', page > 1));
      const list = document.createElement('ul');
      list.className = 'cpp-page-nav__pages';
      let previousNumber = 0;
      const numbers = [...new Set([1, page-1, page, page+1, pages].filter(number => number >= 1 && number <= pages))].sort((a,b) => a-b);
      numbers.forEach(number => {
        if (number > previousNumber + 1) {
          const gap = document.createElement('li');
          gap.textContent = '…';
          gap.className = 'cpp-page-nav__ellipsis';
          list.append(gap);
        }
        const li = document.createElement('li');
        const control = this.pageControl(number, String(number), 'cpp-page-nav__number', true, number === page);
        control.setAttribute('aria-label', `${this.config.page} ${number}`);
        li.append(control);
        list.append(li);
        previousNumber = number;
      });
      this.nav.append(list, this.pageControl(page + 1, `${this.config.next} →`, 'cpp-page-nav__direction', page < pages));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-sidebar-layout-check"]) return;
  try {
    
(() => {
  const start = () => {
    const output = document.querySelector('[data-cpp-sidebar-check]');
    if (!output) return;
    const deadline = Date.now() + 35000;
    const inspect = () => {
      const component = document.querySelector('cpp-listing-sidebar-selector');
      if (!component?.loaded || component.dataset.cplLoaded !== 'true') {
        if (Date.now() < deadline) return setTimeout(inspect, 250);
        output.textContent = JSON.stringify({completed:false, reason:'Selector did not finish loading', found:!!component, mounted:component?.dataset.cplMounted || '', status:component?.querySelector('[data-cpl-status]')?.textContent || ''});
        return;
      }
      try {
        const sidebar = component.closest('aside.cpp-filters');
        const grid = document.querySelector('.cpp-results .cpp-product-grid');
        const results = document.querySelector('.cpp-results');
        const counter = results.querySelector('.cpp-results__toolbar > span');
        const box = component.getBoundingClientRect();
        const mainBox = results.getBoundingClientRect();
        const select = component.querySelector('[data-cpl-select]');
        const parts = () => [...grid.querySelectorAll('.cpp-card__part strong')].map(node => node.textContent.trim());
        const report = {completed:true, viewport:innerWidth, insideLeftAside:!!sidebar, sidebarRight:box.right, productAreaLeft:mainBox.left, sideBySide:box.right <= mainBox.left && innerWidth >= 900, oldFiltersHidden:!!sidebar && getComputedStyle(sidebar.querySelector(':scope > form')).display === 'none', initialCount:counter.textContent.trim(), initialCards:parts().length, optionCount:select.options.length, optionsEnabled:!select.disabled, horizontalOverflow:document.documentElement.scrollWidth > innerWidth};
        select.value = 'hose32';
        select.dispatchEvent(new Event('change', {bubbles:true}));
        report.filteredParts = parts();
        report.filteredCount = counter.textContent.trim();
        report.filterPass = report.filteredParts.length === 1 && report.filteredParts[0] === 'HFUD212T027';
        component.querySelector('[data-cpl-reset]').click();
        report.resetCount = counter.textContent.trim();
        report.resetCards = parts().length;
        report.resetPass = select.value === '' && report.resetCount === report.initialCount;
        report.supportLink = component.querySelector('.cpl-links a:last-child').getAttribute('href');
        output.textContent = JSON.stringify(report, null, 2);
      } catch (error) {output.textContent = JSON.stringify({completed:false,error:String(error)});}
    };
    inspect();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
